import React, { useState } from "react";
import { Card } from "reactstrap";

const PackageSelector = ({ onSelect }) => {
  const [selected, setSelected] = useState("-Select-");

  const packages = [
    "-Select-",
    "Admin Send Intrest",
    "To Answer",
    "From Answer",
    "To Reject",
    "From Reject",
    "To Horoscope",
    "From Horoscope",
    "To Reject Horoscope",
    "From Reject Horoscope",
    "Two side Reject Horoscope",
    "Wait for Meet",
    "Rejected Profiles",
  ];
const handleChange = (value, index) => {
  setSelected(value);
  if (onSelect) onSelect(value, index - 1); 
 
};

  return (
    <Card body className="p-3">
      <select
        className="form-select mb-3"
        value={selected}
        onChange={(e) => {
          const idx = e.target.selectedIndex;
          handleChange(e.target.value, idx);
        }}
      >
        {packages.map((pkg) => (
          <option key={pkg} value={pkg}>
            {pkg}
          </option>
        ))}
      </select>

      {/* {selected !== "-Select-" && (
        <ul className="list-group">
          <li className="list-group-item">{selected}</li>
        </ul>
      )} */}
    </Card>
  );
};

export default PackageSelector;
